module.exports = __webpack_public_path__ + "media/St 4-EMU-hint.bf1b5a2a.wav";